import { useContext } from 'react'
import styled, { css } from 'styled-components'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faAngleDoubleRight, faAngleDoubleLeft } from '@fortawesome/free-solid-svg-icons'
import monthlyBudgetIcon from '../../assets/icons/monthly-budget.svg'
import csmIcon from '../../assets/icons/csm.svg'
import logo from '../../assets/images/logo.png'
import logoSmall from '../../assets/images/logo-small.png'
import Nav from './Nav/Nav'
import MonthlyBudget from './MonthlyBudget'
import UserProfile from './UserProfile'
import EntitlementStatus from './EntitlementStatus'
import CollapseContext from '../../context/CollapseContext'

const Box = styled.div`
  width: ${p => (p.collapsed ? '60px' : '293px')};
  background-color: var(--color-bg-sidebar);
  min-height: 100vh;
  margin-right: 44px;
  display: flex;
  flex-direction: column;
  padding-bottom: 30px;
  transition: width 0.5s ease;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.1);
`

const Img = styled.img`
  ${p =>
    p.sm &&
    css`
      width: 37px;
      height: 37px;
    `}
`

const IconCol = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const IconBox = styled.div`
  display: flex;
  position: relative;

  :hover {
    background: var(--color-hover);

    section {
      display: flex;
    }
  }

  > img {
    padding: 10px 14px;
    opacity: 0.7;
    cursor: pointer;
    transition: opacity 0.2s ease;

    :hover {
      opacity: 1;
    }

    path {
      width: 100% important!;
    }
  }
`

const Abs = styled.section`
  position: absolute;
  bottom: 0;
  left: 60px;
  background: var(--color-bg-sidebar);
  z-index: 12;
  padding-bottom: 25px;
  display: none;
  width: 293px;
  border-radius: 0 8px 8px 0;
  box-shadow: 2px 0 8px rgba(0, 0, 0, 0.2);
`

const ResizeBox = styled.div`
  padding: 31px 10px 96px 27px;
  width: 100%;
  align-self: flex-start;
  display: flex;
  align-items: center;
  ${p =>
    p.small
      ? `flex-direction: column; padding: 31px 0 96px 0`
      : `justify-content: space-between`};

  & > * {
    cursor: pointer;
    transition: all 0.2s ease;
  }

  & > *:not(:last-child) {
    margin: ${p => (p.small ? '0 0 10px 0' : '0 10px 0 0')};
  }

  .sidebar-maximize,
  .sidebar-minimize {
    color: var(--color-text-primary);
    opacity: 0.8;
    font-size: 16px;

    &:hover {
      opacity: 1;
      color: var(--color-secondary);
    }
  }
`

const SideNav = () => {
  const { collapsed, setCollapsed } = useContext(CollapseContext)

  const onCollapse = () => setCollapsed(i => !i)

  return (
    <Box collapsed={collapsed}>
      {collapsed ? (
        <ResizeBox small={true}>
          <Img sm src={logoSmall} alt='brand-logo' onClick={onCollapse} />
          <FontAwesomeIcon className='sidebar-maximize' onClick={onCollapse} icon={faAngleDoubleRight} />
        </ResizeBox>
      ) : (
        <ResizeBox>
          <Img src={logo} style={{width:"80%"}} alt='brand-logo' onClick={onCollapse} />
          <FontAwesomeIcon className='sidebar-minimize' onClick={onCollapse} icon={faAngleDoubleLeft} />
        </ResizeBox>
      )}
      <Nav collapsed={collapsed} />
      {collapsed ? (
        <IconCol>
          <IconBox>
            <img src={monthlyBudgetIcon} alt='monthly-budget-icon' />
            <Abs>
              <MonthlyBudget />
            </Abs>
          </IconBox>
          <IconBox>
            <img src={csmIcon} alt='csm-icon' />
            <Abs>
              <UserProfile />
            </Abs>
          </IconBox>
        </IconCol>
      ) : (
        <>
          <MonthlyBudget />
          <EntitlementStatus />
          <UserProfile />
        </>
      )}
    </Box>
  )
}

export default SideNav
